import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotHomeAppliancesComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotHomeAppliances',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M19.12 2.88C18.56 2.32 17.8 2 17 2H7c-.8 0-1.56.32-2.12.88S4 4.21 4 5V6.01h16V5c0-.79-.32-1.56-.88-2.12Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#A26AFF",
    d: "M4 6h16v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M12 17.041a3.541 3.541 0 1 0 0-7.082 3.541 3.541 0 0 0 0 7.082Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#A26AFF",
    d: "M16.687 5.006h-2.35c-.55 0-1-.45-1-1s.45-1 1-1h2.35c.55 0 1 .45 1 1s-.45 1-1 1Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2A4FF",
    fillRule: "evenodd",
    d: "M6.55 12.728a.982.982 0 0 0-1.023.978.982.982 0 0 0 1.095.971A5.508 5.508 0 0 0 11.995 19c2.31 0 4.29-1.43 5.104-3.45a.981.981 0 0 0 1.374-.895v-2.3a.981.981 0 0 0-1.37-.896A5.507 5.507 0 0 0 11.995 8a5.507 5.507 0 0 0-5.446 4.728Zm5.445-2.76a3.542 3.542 0 1 0 0 7.085 3.542 3.542 0 0 0 3.543-3.543 3.542 3.542 0 0 0-3.543-3.543Z"
  }));
};
SpotHomeAppliancesComponent.displayName = 'SpotHomeAppliances';
export var SpotHomeAppliances = withProvisionalOverrideFromContext(SpotHomeAppliancesComponent);
//# sourceMappingURL=index.js.map